import clsx from 'clsx';
import { ComponentPropsWithRef, createElement } from 'react';
import { colorsClassName, generateTestId, variants, variantsClassName } from './data';

export interface TypographyProps<Variant> {
  variant: Variant;
  color?: keyof typeof colorsClassName;
  noWrap?: boolean;
  dataTestId?: string;
}

const Typography = <Variant extends keyof typeof variants>(
  props: TypographyProps<Variant> & ComponentPropsWithRef<(typeof variants)[Variant]>,
) => {
  const { children, variant, color = 'inherit', className, noWrap, dataTestId, ...rest } = props;

  const testIds = generateTestId(dataTestId || 'typography');

  return createElement(
    variants[variant],
    {
      className: clsx(className, 'block', variantsClassName[variant], colorsClassName[color], {
        'overflow-hidden whitespace-nowrap overflow-ellipsis font-Onest': noWrap,
      }),
      'data-testid': testIds.component,
      ...rest,
    },
    children,
  );
};

export default Typography;
